import React, { useEffect, useState } from 'react';
import SelectField from '../../../../FormControl/input/SelectField';
import { Skeleton, Typography } from '@mui/material';
import { getPeriodicalReport } from '../../../../../services/periodical-report/periodical-report.service';
import isEmpty from 'lodash/isEmpty';
import { handlerErrorV2 } from '../../../../../utils/errors';

const SelectPeriodicalReport = ({ id, name, value, error, disabled, isPreview, loading, onChange  }) => {
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [errorFetch, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      setError(null);
      try {
        const response = await getPeriodicalReport({ status: 'closed' });
        if (!response?.data && response?.error) {
          setError(response.error.message || 'An error ocurred');
        } else {
          setData(response?.data || null);
        }
      } catch (error) {
        const message = handlerErrorV2(error);
        setError(message);
      } finally {
        setIsLoading(false);
      }
    };
    fetchData();
  }, []);

  if (isPreview) {
    const find = data?.find((item) => item._id === value);
    if (find) {
      return (
        <Typography>{isLoading ? <Skeleton /> : data?.find((item) => item._id === value)?.name}</Typography>
      );
    } else {
      return (
        <Typography className='text-muted-foreground opacity-50'>No selected</Typography>
      );
    }

  }
  if (isEmpty(data)) {
    return (
      <Typography className='text-muted-foreground opacity-50'>No periodical report available</Typography>
    );
  }
  return (
    <SelectField
      id={id}
      error={errorFetch || error}
      helperText={errorFetch || error}
      value={value}
      name={name}
      onChange={onChange}
      options={data?.map((item) => ({ value: item._id, label: item.name })) || []}
      placeholder='Choose a curriculum'
      loading={isLoading || loading}
      disabled={isLoading || disabled || loading}
    />
  );
};

export default SelectPeriodicalReport;
